import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { hot } from 'react-hot-loader';
import { createBrowserHistory } from 'history';
import { ApolloProvider } from '@apollo/client';
import LypComponent from '../ListYourPropertyPage';
import { generateApolloClient } from '../../utils/GqlUtil';
import '@ferris/react/js/bundles/epc-ui-core-react';
import 'epc-ui-core/js/ferris-flags-standard.min';

require('isomorphic-fetch');

export const history = createBrowserHistory();

const apolloOptions = {};
let analytics;
if (typeof window === 'object' && window.ha && window.ha.siteName) {
    // eslint-disable-next-line global-require
    analytics = require('../../utils/bepAnalytics');
    // Use both site and siteName because different tools use one or the other.
    apolloOptions.queryParams = {
        siteName: window.ha.siteName,
        site: window.ha.siteName
    };
}

const client = generateApolloClient(apolloOptions);

export const ClientApp = () => (
    <ApolloProvider client={client}>
        <ConnectedRouter history={history}>
            <LypComponent analytics={analytics} />
        </ConnectedRouter>
    </ApolloProvider>
);

export default hot(module)(ClientApp);
